import Chart from "react-apexcharts";
import type { PerformanceChartData } from "@repo/api";

const TimelineChart = ({
  isLoading,
  chartData,
  chartOptions,
  chartSeries,
}: {
  isLoading: boolean;
  chartData?: PerformanceChartData;
  chartOptions: ApexCharts.ApexOptions;
  chartSeries: {
    name: string;
    data: {
      x: number;
      y: number;
    }[];
  }[];
}) => {
  return (
    <div>
      <div className="h-96">
        {isLoading ? (
          <div className="h-full bg-gray-200 rounded animate-pulse flex items-center justify-center">
            <span className="text-gray-500">
              {isLoading ? "Loading chart..." : "Loading chart data..."}
            </span>
          </div>
        ) : chartData ? (
          <Chart
            options={chartOptions}
            series={chartSeries}
            type="line"
            height="100%"
          />
        ) : (
          <div className="h-full bg-gray-100 rounded flex items-center justify-center">
            <div className="text-center text-gray-500">
              <div className="text-4xl mb-2">📊</div>
              <p>Chart data not available</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TimelineChart;
